import { DPDParcelMachine } from '../types/shipping';

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY;

export async function getDPDParcelMachines(): Promise<DPDParcelMachine[]> {
  try {
    // Ensure this URL points to your DPD Edge Function
    const response = await fetch(`${SUPABASE_URL}/functions/v1/dpd-lockers`, {
      headers: {
        'Authorization': `Bearer ${SUPABASE_ANON_KEY}`,
        'Content-Type': 'application/json',
      },
      method: 'GET',
    });
    
    if (!response.ok) {
      throw new Error('Failed to fetch DPD parcel machines from Supabase Edge Function');
    }
    
    const data = await response.json();
    
    // The Edge Function should return data in the desired format, so no further mapping needed here
    return data;
  } catch (error) {
    console.error('Error fetching DPD parcel machines:', error);
    return [];
  }
}
